import { useIsRoadmapReadonly } from '../../../shared/hooks/useIsRoadmapReadonly'
import { useCanCommentOnRoadmap } from '../../../shared/hooks/useCanCommentOnRoadmap'
import { useIsSnapshotMode } from '../../../shared/hooks/useIsSnapshotMode'

export const useTppPermissions = () => {
    const isReadonlyMode = useIsRoadmapReadonly()
    const canComment = useCanCommentOnRoadmap()
    const isSnapshotMode = useIsSnapshotMode()

    return {
        canEdit: !isReadonlyMode && !isSnapshotMode,
        canComment: !isSnapshotMode && canComment,
        isReadonly: isReadonlyMode || isSnapshotMode,
    }
}
